import { render } from "./StudentsListEmpty.vue?vue&type=template&id=5eb9e5f7&scoped=true"
import script from "./StudentsListEmpty.vue?vue&type=script&lang=js"
export * from "./StudentsListEmpty.vue?vue&type=script&lang=js"

import "./StudentsListEmpty.vue?vue&type=style&index=0&id=5eb9e5f7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb9e5f7"]])

export default __exports__